//import { useState } from "react";
// import { useContext, useEffect } from "react";
// import { AppContext } from "../context/useAppContext";
import Search from "./Search";
import Size from "./Size";

export const Nav = () => {
//  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const [appState, setAppState] = useContext(AppContext);



  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };
  // const changeCategory = (name) => {
  //   if (name !== "All Icons") {
  //     let _renderIcons = appState.icons.filter((item) => {
  //       return item.category === name;
  //     });
  //     setAppState({
  //       ...appState,
  //       selectedCategory: name,
  //       selectedCategoryIcons: _renderIcons,
  //     });
  //   } else {
  //     setAppState({
  //       ...appState,
  //       selectedCategory: name,
  //       selectedCategoryIcons: appState.icons,
  //     });
  //     // console.log(".......... ", name);
  //   }
  //   setIsMenuOpen(false);
  // };
  return (
    <>
      <nav className="bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-gray-800">
        <div className="container flex flex-wrap justify-between items-center mx-auto">
          <a href="https://flowbite.com" className="flex items-center">
            <span className="self-center text-md font-semibold whitespace-nowrap dark:text-white">
             SVG ICON GALLERY
            </span>
          </a>
          <div className="flex md:order-2">
            <div className="hidden relative mr-3 md:mr-0 md:block">
              <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                <svg
                  className="w-5 h-5 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
              <Search />
            </div>
          </div>
          <div className=" justify-between items-center w-full md:flex md:w-auto md:order-1">
            {/* <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
              <li>
                <button
                  onClick={toggleMenu}
                  className="flex justify-between items-center py-2 pr-4 pl-3 w-full font-medium text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-gray-400 dark:hover:text-white dark:focus:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
                >
                  {appState.selectedCategory}
                  <svg
                    className="ml-1 w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>

                <div
                  className={
                    "absolute z-10 w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 " +
                    (!isMenuOpen ? "hidden" : "")
                  }
                >
                  <ul className="py-1 text-sm text-gray-700 dark:text-gray-400">
                    {appState.categories.map((item, index) => {
                      return (
                        <li
                          key={index}
                          className={
                            "block p-3 text-left cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          }
                          onClick={() => {
                            changeCategory(item);
                          }}
                        >
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            </ul> */}
            <Size/>
          </div>
        </div>
      </nav>
    </>
  );
};
